/* @ngInject */
function GuestController ($scope, $translate, $timeout, $rootScope, $state, $http, GuestService) {
  const deregisterStateChangeSuccess = $scope.$on('$stateChangeSuccess', (event, state) => {
    if (state.name === 'guest') {
      $state.go('guest.home')
    }
  })

  $scope.$on('$destroy', () => {
    deregisterStateChangeSuccess()
  })
}

export { GuestController }
